import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { Row } from "@faire/web--source/slate/Layout";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";
import styled, { keyframes } from "styled-components";
var getAnimationTypeSuggestions = function(strictLocalize) {
    return [
        strictLocalize({
            id: "y4LR/U",
            defaultMessage: [
                {
                    type: 0,
                    value: "\u201Choliday decorations\u201D"
                }
            ]
        }),
        strictLocalize({
            id: "CcDwFq",
            defaultMessage: [
                {
                    type: 0,
                    value: "\u201Cdresses\u201D"
                }
            ]
        }),
        strictLocalize({
            id: "kJ8x8I",
            defaultMessage: [
                {
                    type: 0,
                    value: "\u201Cthrow blankets\u201D"
                }
            ]
        }),
        strictLocalize({
            id: "ojYRkn",
            defaultMessage: [
                {
                    type: 0,
                    value: "\u201Cgreeting cards\u201D"
                }
            ]
        }),
        strictLocalize({
            id: "PyH37Z",
            defaultMessage: [
                {
                    type: 0,
                    value: "\u201Chair clips\u201D"
                }
            ]
        }),
        strictLocalize({
            id: "ZvoAO0",
            defaultMessage: [
                {
                    type: 0,
                    value: "\u201Cdog treats\u201D"
                }
            ]
        }),
        strictLocalize({
            id: "v9f1w7",
            defaultMessage: [
                {
                    type: 0,
                    value: "\u201Cvases\u201D"
                }
            ]
        }),
        strictLocalize({
            id: "kWSR+h",
            defaultMessage: [
                {
                    type: 0,
                    value: "\u201Cchildren books\u201D"
                }
            ]
        }),
        strictLocalize({
            id: "AmFVkI",
            defaultMessage: [
                {
                    type: 0,
                    value: "\u201Cessential oils\u201D"
                }
            ]
        }),
        strictLocalize({
            id: "JCYkBM",
            defaultMessage: [
                {
                    type: 0,
                    value: "\u201Ccoffee beans\u201D"
                }
            ]
        }),
        strictLocalize({
            id: "Sx4025",
            defaultMessage: [
                {
                    type: 0,
                    value: "\u201Csauces\u201D"
                }
            ]
        })
    ];
};
export var SearchSuggestionAnimation = function() {
    var strictLocalize = useStrictLocalization().strictLocalize;
    var animationTyping = getAnimationTypeSuggestions(strictLocalize);
    return /*#__PURE__*/ _jsxs(AnimationContainer, {
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                color: Core.text.subdued,
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "0hRBOm",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Search for"
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(AnimationPlaceholder, {
                children: animationTyping.map(function(placeholder) {
                    return /*#__PURE__*/ _jsx("li", {
                        children: /*#__PURE__*/ _jsx(Typography, {
                            color: Core.text.subdued,
                            children: placeholder
                        })
                    }, placeholder);
                })
            })
        ]
    });
};
var AnimationContainer = styled(Row).withConfig({
    componentId: "sc-e57989e5-0"
})([
    "position:absolute;top:10px;left:20px;height:20px;pointer-events:none;user-select:none;overflow:hidden;"
]);
var scrollUpAnimation = keyframes([
    "0%,4.76%{transform:translateY(0%);}7.14%{transform:translateY(-103%);}9.52%,14.28%{transform:translateY(-100%);}16.66%{transform:translateY(-203%);}19.04%,23.80%{transform:translateY(-200%);}26.18%{transform:translateY(-303%);}28.56%,33.32%{transform:translateY(-300%);}35.70%{transform:translateY(-403%);}38.08%,42.84%{transform:translateY(-400%);}45.22%{transform:translateY(-503%);}47.60%,52.36%{transform:translateY(-500%);}54.74%{transform:translateY(-603%);}57.12%,61.88%{transform:translateY(-600%);}64.26%{transform:translateY(-703%);}66.64%,71.40%{transform:translateY(-700%);}73.78%{transform:translateY(-803%);}76.16%,80.92%{transform:translateY(-800%);}83.30%{transform:translateY(-903%);}85.68%,90.44%{transform:translateY(-900%);}92.82%{transform:translateY(-1003%);}95.20%,97.60%{transform:translateY(-1000%);}98.80%{transform:translateY(3%);}100%{transform:translateY(0%);}"
]);
var AnimationPlaceholder = styled.ul.withConfig({
    componentId: "sc-e57989e5-1"
})([
    "height:100%;margin-left:4px;animation:",
    " 33s cubic-bezier(0.34,1.56,0.64,1) infinite;"
], scrollUpAnimation);
